module.exports = __webpack_public_path__ + "static/media/gryphon_g_background.5d95c292.png";